module.exports = __webpack_public_path__ + "img/align-center.0e2c58f6.svg";